<template>

<div class="skills_scores_container container">

    <div class="columns" v-if="evaluation">
        <div class="column">
            <div class="scores_columns_container">

                <h3 class="dim_cat_title">{{ $t('dimensions.sight2.titles.game_rules') }}</h3>
                <SkillScore :score="gameRulesScores.f1" :refScore="currentRefScores.f1" :scoreDelay="1" :scoreDecal="1" :scoreLabel="labels.f1" />
                <SkillScore :score="gameRulesScores.f2" :refScore="currentRefScores.f2" :scoreDelay="2" :scoreDecal="2" :scoreLabel="labels.f2" />
                <SkillScore :score="gameRulesScores.f3" :refScore="currentRefScores.f3" :scoreDelay="3" :scoreDecal="3" :scoreLabel="labels.f3" />
                <SkillScore :score="gameRulesScores.f4" :refScore="currentRefScores.f4" :scoreDelay="4" :scoreDecal="4" :scoreLabel="labels.f4" />
                <h3 class="dim_cat_title">{{ $t('dimensions.sight2.titles.resolution_strategy') }}</h3>
                <SkillScore :score="resolutionStrategyScores.t" :refScore="currentRefScores.t" :scoreDelay="7" :scoreDecal="7" :scoreLabel="labels.t" :is_5score="true" />
                <SkillScore :score="resolutionStrategyScores.e" :refScore="currentRefScores.e" :scoreDelay="8" :scoreDecal="8" :scoreLabel="labels.e" :is_5score="true" />
                <SkillScore :score="resolutionStrategyScores.s" :refScore="currentRefScores.s" :scoreDelay="9" :scoreDecal="9" :scoreLabel="labels.s" :is_5score="true" />

            </div>
        </div>

        <div class="column">
            <div class="scores_columns_container">
                <h3 class="dim_cat_title">{{ $t('dimensions.sight2.titles.behavioral_skills') }}</h3>
                <SkillScore :score="behavioralSkillsScores.t1" :refScore="currentRefScores.t1" :scoreDelay="1" :scoreDecal="1" :scoreLabel="labels.t1" />
                <SkillScore :score="behavioralSkillsScores.t2" :refScore="currentRefScores.t2" :scoreDelay="2" :scoreDecal="2" :scoreLabel="labels.t2" />
                <SkillScore :score="behavioralSkillsScores.t3" :refScore="currentRefScores.t3" :scoreDelay="3" :scoreDecal="3" :scoreLabel="labels.t3" />
                <SkillScore :score="behavioralSkillsScores.t4" :refScore="currentRefScores.t4" :scoreDelay="4" :scoreDecal="4" :scoreLabel="labels.t4" />
                <SkillScore :score="behavioralSkillsScores.t5" :refScore="currentRefScores.t5" :scoreDelay="5" :scoreDecal="5" :scoreLabel="labels.t5" />
                <SkillScore :score="behavioralSkillsScores.t6" :refScore="currentRefScores.t6" :scoreDelay="6" :scoreDecal="6" :scoreLabel="labels.t6" />
            </div>
        </div>
        <div class="column">
            <div class="scores_columns_container">
                <h3 class="dim_cat_title">{{ $t('dimensions.sight2.titles.transversal_skills') }}</h3>
                <SkillScore :score="transversalSkillsScores.c1" :refScore="currentRefScores.c1" :scoreDelay="5" :scoreDecal="5" :scoreLabel="labels.c1" />
                <SkillScore :score="transversalSkillsScores.c2" :refScore="currentRefScores.c2" :scoreDelay="6" :scoreDecal="6" :scoreLabel="labels.c2" />
                <SkillScore :score="transversalSkillsScores.c3" :refScore="currentRefScores.c3" :scoreDelay="7" :scoreDecal="7" :scoreLabel="labels.c3" />
                <SkillScore :score="transversalSkillsScores.c4" :refScore="currentRefScores.c4" :scoreDelay="8" :scoreDecal="8" :scoreLabel="labels.c4" />
            </div>
        </div>
    </div>
</div>

</template>

<script>
import SkillScore from "./skillScore";
import sight2DimLabels from '@/locales/sight2DimLabels'

export default {
    name: 'Sight2Scores',
    props: ['evaluation', 'currentRef'],
    components: {
        SkillScore
    },
    data(){
        return {
        }
    },
    computed: {
        gameRulesScores(){
            return this.evaluation.saven_test.game_rules_scores
        },
        transversalSkillsScores(){
            return this.evaluation.saven_test.transversal_skills_scores
        },
        resolutionStrategyScores(){
            return this.evaluation.saven_test.resolution_strategy_scores
        },
        behavioralSkillsScores(){
            return this.evaluation.saven_test.behavioral_skills_scores
        },
        currentRefScores(){
            return this.currentRef.sight2_scores
        },
        labels(){
            return sight2DimLabels[this.$i18n.locale]
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.skills_scores_container{
    margin: 20px auto;
    .scores_columns_container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .dim_cat_title{
            max-width: 280px;
            min-width: 280px;
        }
        .scores_container{
            max-width: 280px;
            min-width: 280px;
        }
    }
}


</style>
